<hpo-layout *ngIf="isLoggedIn"
    [currentUser]="currentUser"
    [productId]="productId"
    [deputyFeatureProductId]="deputyFeatureProductId"
    [claims]="claims"
    [locationUri]="locationUri"
    [applicationSearchTemplate]="applicationSearchContent"
    [floatingActionButtonTemplate]="floatingActionButtonContent"
    [mainTemplate]="mainContent"
    [menuItems]="menuItems"
    [productionMode]="productionMode"
    [environmentVariables]="environmentVariables"
    [accountBaseUri]="accountBaseUri"
    [portalBaseUri]="portalBaseUri"
    [backendAccountUri]="backendAccountUri"
    [backendPortalUri]="backendPortalUri"
    [searchActive]="searchActive"
    [showMessages]="true"
    applicationName="{{ applicationPage }}"
    applicationNameShort="IWM"
    [appVersion]="appVersion"
    (logoutClicked)="logOut()"
    (sidenavToggled)="sidenavToggleChanged($event)"
    [chatEnabled]="aiChatFeatureEnabled && floatingChatService.chatVisible"
    [chatData]="floatingChatService.chatData"
    (chatMessageSent)="floatingChatService.handleChatMessageSent($event)"
    (chatReset)="floatingChatService.handleChatReset()">

    <ng-template #applicationSearchContent>
        <div class="btn-group">

            <div class="btn-col">
                <div id="open-with-id-container"
                    [ngClass]="{'open-with-id-container-handset': mobile,'open-with-id-container-desktop': !mobile}">
                    <div id="open-with-id-input">
                        <form (submit)="searchWithIwmId()">
                            <mat-form-field id="task-id-field">
                                <mat-label>{{ 'task.openWithId' | blah }}</mat-label>
                                <input #openWithIdField
                                    matInput
                                    id="open-with-id-field"
                                    name="openWithIdField"
                                    [(ngModel)]="searchId"
                                    maxlength="10"
                                    inputmode="numeric"
                                    pattern="[0-9]*"
                                    digitOnly>
                                <mat-icon matSuffix
                                    (click)="searchWithIwmId()">arrow_forward</mat-icon>
                            </mat-form-field>
                        </form>
                    </div>
                </div>
            </div>

            <div class="btn-col">
                <ng-container *ngIf="mapVisibleInRoute && !mobile">
                    <hpo-button id="map-toggle-btn"
                        (click)="splitAreaService.toggleMapVisibility()">
                        <mat-icon [ngClass]="{ 'toggle-active': showMap }">map</mat-icon>
                        <div class="toggle-btn-text"
                            [ngClass]="{ 'toggle-active': showMap }">
                            {{ 'filter.map' | blah }}
                        </div>
                    </hpo-button>
                </ng-container>
            </div>

            <div *ngIf="ff_iwiSplitView"
                class="btn-col">
                <ng-container *ngIf="iwiVisibleInRoute && !mobile">
                    <hpo-button id="instructions-toggle-btn"
                        (click)="splitAreaService.toggleIwiVisibility()">
                        <mat-icon [ngClass]="{ 'toggle-active': showIwi }">book_4</mat-icon>
                        <span class="toggle-btn-text"
                            [ngClass]="{ 'toggle-active': showIwi }">
                            {{ 'filter.iwi' | blah }}
                        </span>
                    </hpo-button>
                </ng-container>
            </div>

        </div>
    </ng-template>

    <ng-template #floatingActionButtonContent>
        <hpo-floating-action-button [mobile]="mobile"
            [id]="'app-bar-fab'">
        </hpo-floating-action-button>
    </ng-template>


    <ng-template #mainContent>
        <div #contentAreaDiv
            class="content-area">

            <as-split direction="horizontal"
                (dragEnd)="splitDragEnd($event)">

                <as-split-area [size]="mapSplitWidth"
                    [visible]="!mobile && showMap && mapVisibleInRoute"
                    minSize="10"
                    maxSize="80"
                    order="1">

                    <div class="map-split"
                        *ngIf="!mobile && showMap && mapVisibleInRoute"
                        #mapSplitDiv>

                        <div class="map-container"
                            [style.height.px]="mapHeight"
                            [style.width.px]="mapWidth">

                            <app-map id="hybrid-map"
                                [items]="mapItems"
                                [highlightItem]="highlightItem"
                                [resizeObservable]="mapResized"
                                leafletId="leaflet-hybrid-map">
                            </app-map>
                        </div>

                    </div>

                </as-split-area>

                <as-split-area [size]="iwiSplitWidth"
                    [visible]="!mobile && showIwi && iwiVisibleInRoute"
                    minSize="10"
                    maxSize="80"
                    order="1">

                    <div class="iwi-split"
                        *ngIf="!mobile && showIwi && iwiVisibleInRoute"
                        #iwiSplitDiv>

                        <div class="iwi-container"
                            [style.height.px]="iwiHeight"
                            [style.width.px]="iwiWidth">
                            <app-iframe id="iwi-iframe-app"
                                [targetUrl]="iwiUrl"
                                (closeFrame)="splitAreaService.toggleIwiVisibility()">
                            </app-iframe>
                        </div>

                    </div>

                </as-split-area>


                <as-split-area [size]="splitAreaSize"
                    order="2">

                    <router-outlet></router-outlet>

                </as-split-area>

            </as-split>

        </div>
    </ng-template>

</hpo-layout>

<div *ngIf="!isLoggedIn">
    <router-outlet></router-outlet>
</div>